import { useEffect } from "react";

/**
 * Tiny global refresh bus for the admin console.
 * Any admin surface can broadcast that student/payment data changed and every
 * mounted widget re-fetches, so edits propagate without a page reload.
 */
const EVENT = "admin:data-updated";

export function broadcastAdminDataUpdated(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function useAdminDataRefresh(handler: () => void): void {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const fn = () => handler();
    window.addEventListener(EVENT, fn);
    return () => window.removeEventListener(EVENT, fn);
  }, [handler]);
}
